import type { CityConfig } from "../city-template/types";

export const santaClaritaConfig: CityConfig = {
  vitalRecordsIcon: "ri-file-text-line",
  city: "Santa Clarita",
  state: "California",
  stateAbbr: "CA",
  slug: "santa-clarita",
  route: "/santa-clarita",
  title: "Emergency Passport Santa Clarita, CA — Expedited & Fast Passport Service | Fast Passport Center",
  metaDescription: "Emergency passport and expedited passport services in Santa Clarita, CA — as fast as 24 hours. Fast passport renewal, same-day help, and child passport expediting for Santa Clarita Valley and northern Los Angeles County travelers. A+ BBB rated, registered State Dept. courier.",
  h1: "Emergency & Expedited Passport Services in Santa Clarita, CA",
  heroSubtitle: "Passport expired before your trip? Need an emergency passport fast? We help Santa Clarita and northern LA County travelers get their expedited passports as quickly as 24 hours. A+ BBB rated. No office visit required.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Santa%20Clarita%20California%20suburban%20landscape%20with%20rolling%20golden%20hills%20and%20master-planned%20communities%2C%20Six%20Flags%20Magic%20Mountain%20visible%20in%20the%20distance%2C%20wide%20greenbelts%20and%20paseo%20paths%20through%20Valencia%20neighborhoods%2C%20warm%20golden%20hour%20sunlight%20over%20the%20Santa%20Clarita%20Valley%2C%20professional%20suburban%20landscape%20photography%20with%20dramatic%20sky%2C%20wide%20panoramic%20view%2C%20no%20visible%20text%20or%20people%2C%20warm%20earth%20tones%20and%20golden%20hills%20of%20Southern%20California&width=1800&height=700&seq=santa-clarita-hero-001&orientation=landscape",
  heroImageAlt: "Santa Clarita California suburban landscape with rolling hills and master-planned communities at golden hour",
  geoPosition: "34.3917;-118.5426",
  geoPlacename: "Santa Clarita, California",
  lastModified: "2026-06-14",
  regionalAgency: {
    name: "Los Angeles Passport Agency",
    address: "11000 Wilshire Blvd Suite 1000, Los Angeles, CA 90024",
    distance: "Located in West LA — approximately 40–55 minutes from Santa Clarita via I-5 and I-405",
  },
  nearbyCitiesZips: [
    { name: "Santa Clarita", zips: "91350, 91351, 91354, 91355, 91380, 91381, 91382, 91383, 91384, 91385, 91386, 91387, 91390" },
    { name: "Valencia", zips: "91354, 91355, 91380, 91381, 91382, 91383, 91384, 91385" },
    { name: "Canyon Country", zips: "91351, 91386, 91387" },
    { name: "Saugus", zips: "91350, 91390" },
    { name: "Newhall", zips: "91321" },
    { name: "Stevenson Ranch", zips: "91381" },
    { name: "Castaic", zips: "91384" },
    { name: "Acton", zips: "93510" },
    { name: "Agua Dulce", zips: "91390" },
    { name: "San Fernando", zips: "91340, 91341, 91342, 91343, 91344, 91345, 91346" },
    { name: "Granada Hills", zips: "91344" },
    { name: "Porter Ranch", zips: "91326" },
  ],
  benefits: [
    { icon: "ri-time-line", title: "24–48 Hour Processing", desc: "Emergency courier submission for urgent Santa Clarita Valley departures" },
    { icon: "ri-shield-check-line", title: "Registered Courier", desc: "U.S. Department of State approved passport expediting" },
    { icon: "ri-user-line", title: "Dedicated Agent", desc: "A real person assigned to your case from start to finish" },
    { icon: "ri-mail-send-line", title: "Document Shipping", desc: "Prepaid overnight labels to our processing center" },
  ],
  internalLinks: [
    { name: "Los Angeles", route: "/los-angeles" },
    { name: "Burbank", route: "/burbank" },
    { name: "Glendale", route: "/glendale" },
    { name: "Pasadena", route: "/pasadena" },
    { name: "Santa Monica", route: "/santa-monica" },
    { name: "Simi Valley", route: "/simi-valley" },
    { name: "Thousand Oaks", route: "/thousand-oaks" },
  ],
  fpcOfficeNote: "Fast Passport Center serves Santa Clarita remotely via secure courier. We do not have a walk-in office in Santa Clarita — our registered couriers hand-deliver your documents directly to U.S. Department of State processing facilities. This is how we achieve 24–48 hour turnaround for Santa Clarita Valley travelers.",
  fpcOfficeAddress: "355 S Grand Ave, Ste 2450, Los Angeles, CA 90071",
  fpcOfficeDistance: "Serving all of the Santa Clarita Valley and northern Los Angeles County",
  serviceAreaIntro: "From the master-planned communities of Valencia to the historic streets of Newhall, from the growing Canyon Country to the scenic Saugus area — Fast Passport Center serves the entire Santa Clarita Valley. We regularly help travelers from Stevenson Ranch, Castaic, and the San Fernando Valley get their passports fast.",
  nearbyCitiesIntro: "We serve all Santa Clarita neighborhoods and nearby northern LA County communities including Valencia, Canyon Country, Newhall, Saugus, Stevenson Ranch, and Castaic. If you are in the Santa Clarita Valley or northern LA County, we have you covered.",
  howItWorksIntro: "Most Santa Clarita travelers complete everything online and ship documents overnight. No need to drive to Los Angeles or wait in line at the regional agency.",
  mistakesIntro: "With Hollywood Burbank Airport (BUR) just 30 minutes away and LAX accessible via I-5, Santa Clarita travelers can't afford passport delays. Here are the most common mistakes we see.",
  testimonialsIntro: "Santa Clarita and northern LA County travelers trust us when their departure is days away. Here is what some of them have to say.",
  faqIntro: "Have questions about expedited passports in Santa Clarita? Here are the most common ones we hear from Santa Clarita Valley travelers.",
  statePageRoute: "/states/california",
  statePageName: "California",
  dmvWebsite: "https://www.dmv.ca.gov",
  dmvLabel: "California DMV — Official Website",
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Service Area", href: "#service-area" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Comparison", href: "#comparison" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Reserved agency submission", "Predictable turnaround", "Ideal for upcoming trips", "Document review included", "Dedicated agent assigned to your case", "Daily status updates — never left guessing", "Not affected by government shutdowns"],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Reserved agency submission", "Faster than self-service", "Good for planned travel", "Document review included", "Dedicated agent assigned to your case", "Daily status updates — never left guessing", "Not affected by government shutdowns"],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–2",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: ["No courier access — standard mail only", "Workload & wait times shift with shutdowns and budget fights", "In-person clerk appointment required", "No document review — errors cause rejection", "No dedicated agent — you are on your own", "Updates only by physical mail letter", "No phone or email contact for your case", "Can't upgrade speed after submission", "Not suitable if travel is within 10 weeks"],
      highlight: false,
      muted: true,
    },
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: ["Appointment required — no walk-ins allowed", "Life-or-death emergencies only", "Bereavement or medical crisis", "Expect to wait all day or return next day"],
      highlight: false,
      emergency: true,
    },
  ],
  services: [
    {
      icon: "ri-flashlight-line",
      title: "Emergency Passport",
      description: "For travelers with immediate departure needs — as fast as 24 hours for urgent Santa Clarita Valley international flights.",
      bullets: ["24–48 hour turnaround available", "Registered courier hand-delivery", "Flight verification support"],
      badge: "Most Popular",
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-passport-line",
      title: "Passport Renewal",
      description: "Fast renewal for adults with a passport issued within the last 15 years at age 16 or older.",
      bullets: ["No clerk visit required for most", "Mail-in or courier options", "Lost passport replacement available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-add-circle-line",
      title: "New Passport",
      description: "First-time passport application guidance with acceptance clerk appointment support.",
      bullets: ["Acceptance facility locator", "Form DS-11 assistance", "Photo requirement guidance"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-alert-line",
      title: "Lost or Stolen Passport",
      description: "Passport replacement with DS-64 form guidance and police report documentation.",
      bullets: ["DS-64 form assistance", "Identity verification support", "Emergency replacement options"],
      badge: "Urgent",
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Passport services for minors under 16 with parental consent and acceptance clerk support.",
      bullets: ["DS-11 form for minors", "Parental consent guidance", "Both parents presence rules"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-file-edit-line",
      title: "Name Change",
      description: "Passport correction and name change service after marriage, divorce, or legal changes.",
      bullets: ["DS-5504 or DS-82 guidance", "Marriage certificate support", "Court order documentation"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport", description: "Urgent passport processing for travelers with immediate departure needs, as fast as 24 hours." },
    { name: "Passport Renewal", description: "Fast passport renewal for U.S. citizens with a passport issued within the last 15 years at age 16 or older." },
    { name: "New Passport", description: "First-time passport application assistance with step-by-step guidance through the acceptance clerk process." },
    { name: "Lost or Stolen Passport", description: "Passport replacement service for lost or stolen passports, including DS-64 form guidance." },
    { name: "Child Passport", description: "Passport services for minors under 16, with parental consent guidance and acceptance clerk support." },
    { name: "Name Change", description: "Passport correction and name change service after marriage, divorce, or legal name changes." },
  ],
  testimonials: [
    {
      name: "Mark T.",
      location: "Valencia, CA",
      rating: 5,
      text: "My flight to London was in 3 days and my passport had expired. Fast Passport Center got me a new one in 36 hours. Saved our family vacation completely.",
      service: "Emergency Passport",
    },
    {
      name: "Susan K.",
      location: "Santa Clarita, CA",
      rating: 5,
      text: "Needed to renew for a business trip to Tokyo. The process was smooth, they reviewed my documents, and I had my passport in 4 days. Highly recommend.",
      service: "Passport Renewal",
    },
    {
      name: "David R.",
      location: "Canyon Country, CA",
      rating: 5,
      text: "Lost my passport the week before my honeymoon to Italy. They walked me through the DS-64 process and got me a replacement in 48 hours. Incredible service.",
      service: "Lost Passport",
    },
    {
      name: "Jennifer M.",
      location: "Stevenson Ranch, CA",
      rating: 5,
      text: "As a frequent international traveler from the Santa Clarita Valley, I can't afford passport delays. Fast Passport Center has been my go-to for years. Professional and reliable.",
      service: "Expedited Renewal",
    },
  ],
  facilities: [
    {
      id: "sc-1",
      name: "Santa Clarita Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "24355 Creekside Rd",
      city: "Santa Clarita",
      state: "CA",
      zip: "91355",
      phone: "(661) 254-0100",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "0.5 miles from Valencia Town Center",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Acceptance hours are limited. Appointments required. Call ahead to confirm passport acceptance times.",
      icon: "ri-mail-line",
    },
    {
      id: "sc-2",
      name: "Newhall Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "23764 Lyons Ave",
      city: "Newhall",
      state: "CA",
      zip: "91321",
      phone: "(661) 259-8261",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "0.3 miles from Old Town Newhall",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Busy location — book appointments 2+ weeks in advance. Limited weekend hours.",
      icon: "ri-mail-line",
    },
    {
      id: "sc-3",
      name: "Canyon Country Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "18336 Soledad Canyon Rd",
      city: "Canyon Country",
      state: "CA",
      zip: "91387",
      phone: "(661) 252-1711",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "0.8 miles from Canyon Country Park",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Popular for eastern Santa Clarita Valley residents. Appointment strongly recommended.",
      icon: "ri-mail-line",
    },
    {
      id: "sc-4",
      name: "San Fernando Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "308 S Brand Blvd",
      city: "San Fernando",
      state: "CA",
      zip: "91340",
      phone: "(818) 365-3681",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "8 miles from Santa Clarita",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Convenient for southern Santa Clarita Valley residents. Photo services available. Book ahead.",
      icon: "ri-mail-line",
    },
    {
      id: "sc-5",
      name: "Granada Hills Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "18039 Chatsworth St",
      city: "Granada Hills",
      state: "CA",
      zip: "91344",
      phone: "(818) 363-7441",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "10 miles from Santa Clarita",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Convenient for southern Santa Clarita Valley residents. Limited passport hours — call to confirm.",
      icon: "ri-mail-line",
    },
    {
      id: "sc-6",
      name: "LA County Clerk — Van Nuys",
      type: "County Clerk Passport Acceptance",
      address: "14340 W Sylvan St",
      city: "Van Nuys",
      state: "CA",
      zip: "91401",
      phone: "(818) 374-7176",
      hours: "Mon–Fri: 8:00 AM – 4:30 PM",
      distance: "15 miles from Santa Clarita",
      website: "https://www.lavote.net/",
      websiteLabel: "LA County Clerk",
      notes: "Major county facility with extended hours. Accepts walk-ins but appointments recommended for faster service.",
      icon: "ri-government-line",
    },
  ],
  comparisonRows: [
    { feature: "Appointment Needed", agency: "Yes — call NPIC, limited slots", fpc: "No — we handle everything for you" },
    { feature: "Processing Speed", agency: "Same-day if approved (rare)", fpc: "24–48 hours guaranteed for emergency" },
    { feature: "Document Review", agency: "No — rejected if wrong", fpc: "Yes — we check before submission" },
    { feature: "Travel to Agency", agency: "Yes — downtown LA", fpc: "No — ship from home or office" },
    { feature: "Agent Support", agency: "No — government clerk only", fpc: "Yes — dedicated agent assigned" },
    { feature: "Status Updates", agency: "No — no tracking provided", fpc: "Yes — daily email updates" },
    { feature: "Guaranteed Timing", agency: "No — subject to availability", fpc: "Yes — contractual turnaround times" },
    { feature: "SCV Community Coverage", agency: "No Santa Clarita Valley expertise", fpc: "Santa Clarita Valley, Magic Mountain, and Master Planned Community travel expertise" },
    { feature: "Multi-Person Processing", agency: "Separate appointments per person", fpc: "Handle families and groups in parallel" },
  ],
  mistakes: [
    {
      icon: "ri-image-line",
      title: "Wrong Photo Size or Background",
      description: "Santa Clarita Valley photo shops often use generic sizes. Passport photos must be exactly 2×2 inches with a white or off-white background.",
    },
    {
      icon: "ri-file-list-line",
      title: "Incomplete DS-11 Form",
      description: "Missing signatures or using the wrong form type are the #1 reasons for rejection at Santa Clarita area acceptance facilities.",
    },
    {
      icon: "ri-money-dollar-circle-line",
      title: "Wrong Payment Amount",
      description: "Fees change frequently. Many Santa Clarita applicants show up with incorrect checks and have to reschedule their appointment.",
    },
    {
      icon: "ri-calendar-close-line",
      title: "No Proof of Travel",
      description: "Without flight confirmation or travel itinerary, the LA regional agency will turn you away for emergency appointments.",
    },
    {
      icon: "ri-parent-line",
      title: "Missing Parental Consent",
      description: "For minors, both parents must appear or submit notarized consent. This trips up many Santa Clarita families at the clerk.",
    },
    {
      icon: "ri-time-line",
      title: "Waiting Too Long to Start",
      description: "Santa Clarita travelers often assume standard processing will be fine. It takes 8–11 weeks. Start expedited at least 3 weeks before travel.",
    },
  ],
  steps: [
    { number: "1", icon: "ri-file-list-line", title: "Apply Online", description: "Complete your application on our secure website in under 10 minutes." },
    { number: "2", icon: "ri-mail-send-line", title: "Ship Documents", description: "We send you a prepaid overnight label. Drop your documents at any UPS location in Santa Clarita." },
    { number: "3", icon: "ri-shield-check-line", title: "We Review", description: "Our team checks every document for accuracy before hand-delivering to the State Department." },
    { number: "4", icon: "ri-passport-line", title: "Processing", description: "Your passport is processed at a U.S. Department of State facility using our registered courier slots." },
    { number: "5", icon: "ri-truck-line", title: "Delivery", description: "We overnight your new passport back to your Santa Clarita address — trackable every step of the way." },
  ],
  faqs: [
    { q: "Can I get an emergency passport in Santa Clarita before international travel?", a: "Yes. Fast Passport Center provides emergency passport services in Santa Clarita for travelers with urgent international flights. Our registered couriers achieve 24–48 hour turnaround for most Santa Clarita Valley travelers." },
    { q: "How fast can I renew my passport in Santa Clarita?", a: "Fast Passport Center offers fast passport renewal in Santa Clarita in as little as 24–48 hours through our emergency courier service." },
    { q: "What if my passport expires before my cruise?", a: "If your passport expires before your cruise, contact Fast Passport Center immediately. We can expedite your passport renewal in Santa Clarita in 24–48 hours so you don't miss your departure." },
    { q: "Can I get a same-day passport appointment near Santa Clarita?", a: "Same-day passport appointments are only available at the Los Angeles Passport Agency (11000 Wilshire Blvd Suite 1000, Los Angeles, CA 90024) for documented life-or-death emergencies. For all other urgent travel, Fast Passport Center's 24–48 hour emergency courier processing is the fastest guaranteed option for Santa Clarita residents." },
    { q: "Can I expedite a child passport in Santa Clarita?", a: "Yes. Fast Passport Center expedites child passports in Santa Clarita for minors under 16. Both parents must appear or submit notarized consent, along with the child's birth certificate and both parents' IDs." },
    { q: "What should I do if I lost my passport before a trip?", a: "If you lost your passport before a trip, contact Fast Passport Center immediately. We provide lost passport replacement services in Santa Clarita with DS-64 form guidance. Our emergency courier service can get your replacement passport in 24–48 hours." },
    { q: "How fast can I get a passport in Santa Clarita?", a: "With Fast Passport Center's emergency courier service, Santa Clarita travelers can receive their passport in as little as 24–48 hours. Our registered couriers hand-deliver your documents directly to U.S. Department of State processing facilities, bypassing standard mail delays." },
    { q: "Do I need to drive to the Los Angeles Passport Agency?", a: "No. With Fast Passport Center, you complete everything online and ship your documents overnight. Our couriers handle the in-person delivery to State Department facilities. You only need to visit a local acceptance clerk if you're a first-time applicant or need a name change." },
    { q: "Where are the closest passport acceptance facilities in Santa Clarita?", a: "Popular options include the Santa Clarita Post Office (91355), Newhall Post Office (91321), Canyon Country Post Office (91387), and San Fernando Post Office (91340). All require appointments. We help you find the most convenient location and schedule your visit." },
    { q: "Can I get a same-day passport in Santa Clarita?", a: "Same-day passports are only available at the LA Regional Passport Agency for documented life-or-death emergencies with proof of travel within 72 hours. For all other urgent travel, Fast Passport Center's 24–48 hour emergency processing is the fastest reliable option." },
    { q: "What if I live in Stevenson Ranch or Castaic?", a: "We serve all of the Santa Clarita Valley including Stevenson Ranch, Castaic, Valencia, Canyon Country, and Newhall. Our overnight shipping labels work from any UPS location, so your location within the valley doesn't affect processing speed." },
    { q: "How much does expedited passport service cost in Santa Clarita?", a: "Government fees are fixed: $130 for a passport book (adult) plus a $60 expedite fee. Fast Passport Center's service fees vary by processing speed — emergency 24–48 hour processing, 3–5 day expedited, or standard options. Contact us for a personalized quote based on your timeline." },
    { q: "Do you help with passport photos in Santa Clarita?", a: "We guide you on exact photo requirements and can recommend locations near you. Many CVS, Walgreens, and FedEx locations in Santa Clarita, Valencia, and Canyon Country offer passport photo services. We review your photos before submission to ensure they meet State Department standards." },
    { q: "What documents do I need for a first-time passport in Santa Clarita?", a: "You'll need proof of citizenship (birth certificate or naturalization certificate), government-issued photo ID (driver's license or REAL ID), two passport photos, and payment. We provide a complete checklist and review your documents before you visit the acceptance clerk." },
    { q: "Can you help with a child's passport in Santa Clarita?", a: "Yes. Child passports require both parents (or notarized consent from the absent parent), the child's birth certificate, and both parents' IDs. We walk Santa Clarita Valley families through the entire process and help schedule acceptance clerk appointments." },
  ],
  photoLocations: [
    { name: "CVS Pharmacy — Santa Clarita", address: "26501 Bouquet Canyon Rd, Santa Clarita, CA 91350", hours: "Mon–Sun: 8AM–10PM" },
    { name: "Walgreens — Valencia", address: "24040 Copperhill Dr, Valencia, CA 91355", hours: "Mon–Sun: 7AM–11PM" },
    { name: "FedEx Office — Santa Clarita", address: "26565 Bouquet Canyon Rd, Santa Clarita, CA 91350", hours: "Mon–Fri: 7AM–9PM, Sat: 8AM–6PM" },
    { name: "UPS Store — Valencia", address: "25124 Springfield Ct, Valencia, CA 91355", hours: "Mon–Fri: 8AM–7PM, Sat: 9AM–5PM" },
    { name: "Walmart — Canyon Country", address: "27931 Kelly Johnson Pkwy, Santa Clarita, CA 91355", hours: "Mon–Sun: 6AM–11PM" },
    { name: "Rite Aid — Newhall", address: "23925 Newhall Ave, Newhall, CA 91321", hours: "Mon–Sun: 8AM–10PM" },
    { name: "Postal Annex — Stevenson Ranch", address: "25852 McBean Pkwy, Santa Clarita, CA 91355", hours: "Mon–Fri: 9AM–6PM, Sat: 9AM–4PM" },
    { name: "Costco — Santa Clarita", address: "26418 Carl Boyer Dr, Santa Clarita, CA 91350", hours: "Mon–Fri: 10AM–8:30PM, Sat–Sun: 9:30AM–6PM" },
  ],
  dmvLocations: [
    {
      name: "DMV — Santa Clarita",
      address: "20725 Soledad Canyon Rd, Santa Clarita, CA 91351",
      hours: "Mon–Fri: 8AM–5PM",
      note: "REAL ID and driver's license renewals. Appointment required.",
      featured: true,
    },
    {
      name: "DMV — San Fernando",
      address: "10200 Glenoaks Blvd, Pacoima, CA 91331",
      hours: "Mon–Fri: 8AM–5PM",
      note: "Passport-ready photo services available. Online appointment booking.",
      featured: false,
    },
    {
      name: "DMV — Van Nuys",
      address: "14920 Vanowen St, Van Nuys, CA 91405",
      hours: "Mon–Fri: 8AM–5PM",
      note: "REAL ID processing. Walk-ins limited — book online first.",
      featured: false,
    },
    {
      name: "DMV — Los Angeles (North Hollywood)",
      address: "11239 Camarillo St, North Hollywood, CA 91602",
      hours: "Mon–Fri: 8AM–5PM",
      note: "Full-service center for San Fernando Valley residents.",
      featured: true,
    },
  ],
  airports: [
    {
      code: "BUR",
      name: "Hollywood Burbank Airport",
      distance: "20 miles from Santa Clarita",
      address: "2627 N Hollywood Way, Burbank, CA 91505",
      note: "The closest major airport to Santa Clarita. Domestic flights and some international connections. Less crowded than LAX.",
      flightUrl: "https://www.hollywoodburbankairport.com/",
      flightLabel: "Burbank Airport",
      featured: true,
    },
    {
      code: "LAX",
      name: "Los Angeles International Airport",
      distance: "35 miles from Santa Clarita",
      address: "1 World Way, Los Angeles, CA 90045",
      note: "Major international hub for long-haul flights to Asia, Europe, and South America. Accessible via I-5 and I-405.",
      flightUrl: "https://www.flylax.com/",
      flightLabel: "LAX Flight Info",
      featured: false,
    },
    {
      code: "ONT",
      name: "Ontario International Airport",
      distance: "55 miles from Santa Clarita",
      address: "1923 E Avion St, Ontario, CA 91761",
      note: "Alternative airport with international flights to Mexico. Accessible via I-5 and I-10.",
      flightUrl: "https://www.flyontario.com/",
      flightLabel: "Ontario Airport",
      featured: false,
    },
  ],
  vitalRecordsLinks: [{ icon: "ri-user-smile-line", label: "Birth Certificate", desc: "Request certified birth certificates from California CDPH Vital Records for Los Angeles County.", url: "https://www.cdph.ca.gov/Programs/CHSI/Pages/Vital-Records.aspx" }, { icon: "ri-file-list-2-line", label: "Death Certificate", desc: "Obtain certified death certificates through California CDPH Vital Records.", url: "https://www.cdph.ca.gov/Programs/CHSI/Pages/Vital-Records.aspx" }, { icon: "ri-hearts-line", label: "Marriage Certificate", desc: "Request marriage license records from the LA County Registrar-Recorder.", url: "https://www.lavote.gov/records/" }, { icon: "ri-file-copy-line", label: "Divorce Decree", desc: "Obtain certified divorce records through LA County Superior Court.", url: "https://www.lacourt.org/" }],
};